import { useRxCollectionPatient } from "$global-providers/rxdb-provider/collections/patient";
import { useEffect, useState } from "react";

/**
 * Reads a patient's display name from the rxdb patient collection.
 * Returns `undefined` while loading or if the patient is not yet in the
 * local store — callers must render without it rather than block.
 */
export function useFetchPatientNameRxdb(
  patientId: string | undefined,
): string | undefined {
  const collection = useRxCollectionPatient();
  const [name, setName] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!collection || !patientId) {
      setName(undefined);
      return;
    }
    const sub = collection.findOne(patientId).$.subscribe((doc) => {
      const parts = [doc?.name?.first, doc?.name?.last].filter(Boolean);
      setName(parts.length > 0 ? parts.join(" ") : undefined);
    });
    return () => sub.unsubscribe();
  }, [collection, patientId]);

  return name;
}
